import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { StateService } from '../../../services/state.service';
import { formatDate } from '../../../services/date-utils';
import * as Sentry from '@sentry/angular';
import { BewerberAdapter } from '../../../adapter/bewerber.adapter';
import { take } from 'rxjs/operators';
import { ContactCardComponent } from '../contact-card/contact-card.component';
import { TauresMessageModule } from '@taures/taures-components/taures-message';
import { Button } from 'primeng/button';
import { RouterLink } from '@angular/router';
import { Card } from 'primeng/card';
import { Skeleton } from 'primeng/skeleton';
import { ContactData } from '../../../adapter/dto/contact-data.dto';

@Component({
  selector: 'app-vp-landing',
  templateUrl: './vp-landing.component.html',
  styleUrls: ['./vp-landing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ContactCardComponent, TauresMessageModule, Button, RouterLink, Card, Skeleton],
  standalone: true
})
export class VpLandingComponent implements OnInit {
  protected readonly stateService: StateService = inject(StateService);
  protected readonly bewerberService: BewerberAdapter = inject(BewerberAdapter);

  protected get aweManagerUrl(): string {
    if (!this.stateService.hasValidTokenAndBirthdate()) {
      return '';
    }

    const token: string = this.stateService.getToken()!;
    const birthdate: Date = this.stateService.getBirthdate()!;

    const formattedDate: string = formatDate(birthdate);
    return `/api/vp/awe-manager/avatar?token=${token}&geburtsdatum=${formattedDate}`;
  }

  protected get vpManagerUrl(): string {
    if (!this.stateService.hasValidTokenAndBirthdate()) {
      return '';
    }

    const token: string = this.stateService.getToken()!;
    const birthdate: Date = this.stateService.getBirthdate()!;

    const formattedDate: string = formatDate(birthdate);
    return `/api/vp/vp-manager/avatar?token=${token}&geburtsdatum=${formattedDate}`;
  }

  public ngOnInit(): void {
    if (!this.stateService.hasValidTokenAndBirthdate()) {
      this.stateService.setHasError(true);
      return;
    }

    const token: string = this.stateService.getToken()!;
    const birthdate: Date = this.stateService.getBirthdate()!;
    this.loadAweManager(token, birthdate);
    this.loadVpManager(token, birthdate);
  }

  private loadVpManager(token: string, birthdate: Date): void {
    this.stateService.setIsLoading(true);
    this.stateService.setHasError(false);

    this.bewerberService
      .loadVPManager(token, birthdate)
      .pipe(take(1))
      .subscribe({
        next: (contactData: ContactData): void => {
          this.stateService.setIsLoading(false);
          this.stateService.setHasError(false);
          this.stateService.setVpManager(contactData);
        },
        error: (err: Error): void => {
          Sentry.captureEvent(err);
          this.stateService.setIsLoading(false);
          this.stateService.setHasError(true);
        }
      });
  }

  private loadAweManager(token: string, birthdate: Date): void {
    this.stateService.setIsLoading(true);
    this.stateService.setHasError(false);

    this.bewerberService
      .loadAWEManager(token, birthdate)
      .pipe(take(1))
      .subscribe({
        next: (contactData: ContactData): void => {
          this.stateService.setIsLoading(false);
          this.stateService.setHasError(false);
          this.stateService.setAweManager(contactData);
        },
        error: (error: Error): void => {
          Sentry.captureEvent(error);
          this.stateService.setIsLoading(false);
          this.stateService.setHasError(true);
        }
      });
  }
}
